module.exports = __webpack_public_path__ + "img/2-m.013611a1.jpg";